// import React, { useEffect } from "react";
// import Lottie from "react-lottie";
// import animationData from "./animation.json";

// import {
//   FaPhoneAlt,
//   FaEnvelope,
//   FaInstagram,
//   FaLinkedin,
// } from "react-icons/fa";

// function LottieBlock() {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         flex: 1,
//         aspectRatio: "2",

//         overflow: "hidden",

//         alignItems: "center",
//         justifyContent: "center",
//         width: "100%",
//         // position: "relative",m
//         marginTop: "-3rem",
//       }}
//     >
//       {/* <div
//           style={{
//             position: "absolute",
//             top: "-20px", // crop top

//             left:  "-6px",
//             // bottom: "-300px",
//             right: 0,
//           }}
//         > */}
//       <Lottie options={defaultOptions} width={"120%"} />
//       {/* </div> */}
//     </div>
//   );
// }

// function HouseBlocks() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "16px",
//         width: "100%",
//         padding: "16px",
//         boxSizing: "border-box",
//         background: "#FFF1E8",
//         paddingTop: "3rem",
//         paddingBottom: "3rem",
//       }}
//     >
//       <h2 style={{ color: "#000", marginLeft: "1rem" }}>
//         We Welcome All The Reading Criminals:
//       </h2>
//       <div
//         style={{
//           borderColor: "#EC2227",
//           borderStyle: "solid",
//           borderWidth: "2px",
//           width: "28%",
//           marginLeft: "1rem",
//         }}
//       />
//       <div
//         style={{
//           display: "flex",
//           // flexDirection: 'column',
//           gap: "16px",
//           width: "100%",
//           padding: "16px",
//           boxSizing: "border-box",
//         }}
//       >
//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/xezknfy1/1.jpg"
//             alt="Block 1"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/2inloz3w/2.jpg"
//             alt="Block 2"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/c4bgaozw/3.jpg"
//             alt="Block 3"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>
//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/8g941sub/4.jpg"
//             alt="Block 4"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

function AuthorEventBlocks() {
  return (
    <div
      style={{
        display: "flex",
        //   flexDirection: "column",
        gap: "16px",
        width: "100%",
        padding: "16px",
        boxSizing: "border-box",

        paddingTop: "3rem",
        paddingBottom: "3rem",
      }}
    >
      <div
        style={{
          width: "60%",
          // overflow: "hidden",
          borderRadius: "12px",
          marginRight: "3rem",
                
        }}
      >
        {/* <h2 style={{ color: "var(--accent-10)" }}>Author Spotlight</h2> */}
        <SectionTitle
          title="Author Spotlight"
          width="30%"
          titleColor="var(--text-neutral)"
        />
        <img
          src="https://images.assettype.com/newslaundry/2026-06-08/41hn9bki/Author.png"
          alt="Block 1"
          style={{
            width: "100%",
            // height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "40%",
          // height: "100%",
          // overflow: "hidden",
          borderRadius: "12px",

          justifyContent: "space-between",
        }}
      >
        <SectionTitle
          title="Events"
          width="14%"
          titleColor="var(--text-neutral)"
        />
       <div style={{     }}>
         <img
          src="https://images.assettype.com/newslaundry/2026-06-08/c1v7lsl2/events.png"
          alt="Block 2"
          style={{
            width: "100%",
            // height: "100%",
            objectFit: "contain",
            display: "block",
        
            // margin: "0 auto",
            // marginTop: "4.8rem",
          }}
        />
       </div>
      </div>
    </div>
  );
}

// function UpcomingBookBlocks() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "16px",
//         width: "100%",
//         padding: "16px",
//         boxSizing: "border-box",
//         background: "#FFF1E8",
//         paddingTop: "3rem",
//         paddingBottom: "3rem",
//       }}
//     >
//       <h2 style={{ color: "#000", marginLeft: "1rem" }}>Upcoming Books:</h2>
//       <div
//         style={{
//           borderColor: "#EC2227",
//           borderStyle: "solid",
//           borderWidth: "2px",
//           width: "12%",
//           marginLeft: "1rem",
//         }}
//       />
//       <div
//         style={{
//           display: "flex",
//           // flexDirection: 'column',
//           gap: "16px",
//           width: "100%",
//           padding: "16px",
//           boxSizing: "border-box",
//         }}
//       >
//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/fuu6svlh/card-1-1.png"
//             alt="Block 1"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/bul6b7qp/card-2.png"
//             alt="Block 2"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             flex: 1,
//             aspectRatio: "1 / 1",
//             overflow: "hidden",
//             borderRadius: "16px",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-27/ve9314ck/card-3.png"
//             alt="Block 3"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>
//         {/* <div
//             style={{
//               flex: 1,
//               aspectRatio: "1 / 1",
//               overflow: "hidden",
//               borderRadius: "16px",
//             }}
//           >
//             <img
//               src="https://images.assettype.com/newslaundry/2026-05-27/8g941sub/4.jpg"
//               alt="Block 4"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//                 display: "block",
//               }}
//             />
//           </div> */}
//       </div>
//     </div>
//   );
// }

// function ContactUS() {
//   return (
//     <div style={{ background: "#FFF1E8", padding: "24px" }}>
//       <div>
//         <h2 style={{ color: "#111827", flexBasis: "100%" }}>Contact Us</h2>
//         <div
//           style={{
//             borderColor: "#EC2227",
//             borderStyle: "solid",
//             borderWidth: "2px",
//             width: "8%",
//             // marginLeft: "1rem",
//           }}
//         />
//       </div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           gap: "32px",

//           width: "100%",
//           boxSizing: "border-box",
//           fontFamily: "Arial, sans-serif",
//           flexWrap: "wrap",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "18px",
//             flex: 1,
//             minWidth: "260px",
//           }}
//         >
//           <a
//             href="tel:+919999999999"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "12px",
//               textDecoration: "none",
//               color: "#111827",
//               fontSize: "16px",
//             }}
//           >
//             <FaPhoneAlt size={18} />
//             <span>+91 99999 99999</span>
//           </a>

//           <a
//             href="mailto:support@example.com"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "12px",
//               textDecoration: "none",
//               color: "#111827",
//               fontSize: "16px",
//             }}
//           >
//             <FaEnvelope size={18} />
//             <span>support@example.com</span>
//           </a>

//           <a
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "12px",
//               textDecoration: "none",
//               color: "#111827",
//               fontSize: "16px",
//             }}
//           >
//             <FaInstagram size={18} />
//             <span>Instagram</span>
//           </a>

//           <a
//             href="https://linkedin.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "12px",
//               textDecoration: "none",
//               color: "#111827",
//               fontSize: "16px",
//             }}
//           >
//             <FaLinkedin size={18} />
//             <span>LinkedIn</span>
//           </a>
//         </div>

//         <div
//           style={{
//             flex: 1,
//             minWidth: "260px",
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-28/z6r6226b/contact.png"
//             alt="Contact Us"
//             style={{
//               width: "100%",
//               maxWidth: "420px",
//               borderRadius: "20px",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// function Newsletter() {
//   return (
//     <div
//       style={{
//         width: "100%",
//         aspectRatio: "16 / 5",
//         overflow: "hidden",
//         cursor: "pointer",
//       }}
//     >
//       <img
//         src="https://images.assettype.com/newslaundry/2026-05-28/xslpqm7d/Lastsection.png"
//         alt="About"
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "cover",
//           display: "block",
//         }}
//       />
//     </div>
//   );
// }

// export function BookClubWebPage() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "16px",
//         padding: "16px",
//         width: "100%",
//         boxSizing: "border-box",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "24px",
//         }}
//       >
//         <div
//           style={{
//             width: "100%",
//             aspectRatio: "16 / 10",
//             overflow: "hidden",
//             cursor: "pointer",
//             position: "relative",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-26/ywybki9p/MAIN.jpg"
//             alt="Jumbotron"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />

//           <button
//             style={{
//               position: "absolute",
//               top: "18px",
//               right: "16px",
//               padding: "6px 14px",
//               border: "none",
//               borderRadius: "999px",
//               backgroundColor: "#ffffff",
//               cursor: "pointer",
//               fontWeight: "600",
//               color: "#000",
//             }}
//           >
//             Contact Us
//           </button>
//           <button
//             style={{
//               position: "absolute",
//               bottom: "16px",
//               left: "16px",
//               padding: "6px 14px",
//               border: "none",
//               borderRadius: "999px",
//               backgroundColor: "#ffffff",
//               cursor: "pointer",
//               fontWeight: "600",
//               color: "#000",
//             }}
//           >
//             Join Our Newsletter
//           </button>

//           <button
//             style={{
//               position: "absolute",
//               bottom: "16px",
//               right: "16px",
//               padding: "6px 14px",
//               border: "none",
//               borderRadius: "999px",
//               backgroundColor: "#ffffff",
//               color: "#000",
//               cursor: "pointer",
//               fontWeight: "600",
//             }}
//           >
//             Explore Our Current Book
//           </button>
//         </div>

//         <div
//           style={{
//             width: "100%",
//             aspectRatio: "16 / 7",
//             overflow: "hidden",
//             cursor: "pointer",
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-26/wwh2piq2/ABOUt.jpg"
//             alt="About"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             width: "100%",
//             aspectRatio: "16 / 5",
//             overflow: "hidden",
//             cursor: "pointer",
//           }}
//           onClick={() => {
//             window.location.href = "/book-club";
//           }}
//         >
//           <img
//             src="https://images.assettype.com/newslaundry/2026-05-26/253g35q7/Atomic-habits3x.jpg"
//             alt="Current book"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         </div>
//       </div>

//       <HouseBlocks />
//       <UpcomingBookBlocks />
//       <AuthorEventBlocks />
//       <LottieBlock />
//       <Newsletter />
//       <ContactUs />
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
// import Lottie from "react-lottie";
import animationData from "./animation.json";

import { FaPhoneAlt, FaEnvelope, FaInstagram, FaTwitter } from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";

const buttonStyle = {
  padding: "7px 13px",
  border: "none",
  borderRadius: "999px",
  backgroundColor: "#FFF1E8",
  cursor: "pointer",
  fontWeight: "600",
  color: "#000",
  fontSize: "14px",
};

function LottieBlock() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // preload animation
    if (animationData) {
      setIsLoaded(true);
    }
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (!isLoaded) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        aspectRatio: "2",

        overflow: "hidden",

        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        // position: "relative",m
        marginTop: "-3rem",
      }}
    >
      {/* <div
          style={{
            position: "absolute",
            top: "-20px", // crop top

            left:  "-6px",
            // bottom: "-300px",
            right: 0,
          }}
        > */}
      <Lottie options={defaultOptions} width={"120%"} />
      {/* </div> */}
    </div>
  );
}

function SectionTitle({ title, width = "20%", titleColor = "#000" }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        marginBottom: "1rem",
      }}
    >
      <div
        style={{
          color: titleColor,
          fontFamily: "'Lora', serif",
          fontSize: "2.4rem",
          fontWeight: "bold",
        }}
      >
        {title}
      </div>

      <div
        style={{
          borderColor: "#EC2227",
          borderStyle: "solid",
          borderWidth: "2px",
          width,
          marginBottom: "1rem",
        }}
      />
    </div>
  );
}

function HouseBlocks() {
  return (
    <div
      style={{
        background: "#FFF1E8",
        padding: "clamp(16px, 3vw, 40px)",
      }}
    >
      <SectionTitle title="We Welcome All The Reading Criminals:" width="30%" />

      <div
        style={{
          display: "flex",
          gap: "34px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {[
          "kfik7ppm/abon.png",
          "okam17l3/skip.png",
          "6w82q18c/hoard.png",
          "dmxnire5/crack.png",
        ].map((img, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 220px",
              maxWidth: "250px",
              aspectRatio: "1 / 1",
              // overflow: "hidden",
              // borderRadius: "16px",
            }}
          >
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-29/${[
                img,
              ]}`}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function UpcomingBookBlocks() {
  return (
    <div
      style={{
        background: "#FFF1E8",
        padding: "clamp(16px, 3vw, 40px)",
      }}
    >
      <SectionTitle title="Upcoming Books:" width="14%" />

      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {[
          "y11ymohg/good-things-.png",
          "cc73i5ia/take-.png",
          "24gxxqx1/time-.png",
        ].map((img, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 260px",
              maxWidth: "380px",
              aspectRatio: "1 / 1",
              overflow: "hidden",
              // borderRadius: "16px",
            }}
          >
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-19/${img}`}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

// function AuthorEventBlocks() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexWrap: "wrap",
//         gap: "24px",
//         padding: "clamp(16px, 3vw, 40px)",
//       }}
//     >
//       <div
//         style={{
//           flex: "1 1 500px",
//         }}
//       >
//         <h2 style={{ color: "var(--accent-10)" }}>Author Spotlight</h2>

//         <div
//           style={{
//             borderColor: "#EC2227",
//             borderStyle: "solid",
//             borderWidth: "2px",
//             width: "30%",
//             marginBottom: "1rem",
//           }}
//         />

//         <img
//           loading="lazy"
//           src="https://images.assettype.com/newslaundry/2026-05-27/p14syu9o/Author-spotlight3x.png"
//           alt=""
//           style={{
//             width: "100%",
//             borderRadius: "16px",
//             objectFit: "cover",
//           }}
//         />
//       </div>

//       <div
//         style={{
//           flex: "1 1 320px",
//         }}
//       >
//         <h2 style={{ color: "var(--accent-10)" }}>Events</h2>

//         <div
//           style={{
//             borderColor: "#EC2227",
//             borderStyle: "solid",
//             borderWidth: "2px",
//             width: "20%",
//             marginBottom: "1rem",
//           }}
//         />

//         <img
//           loading="lazy"
//           src="https://images.assettype.com/newslaundry/2026-05-27/bu8ij346/Events3x.jpg"
//           alt=""
//           style={{
//             width: "100%",
//             borderRadius: "16px",
//             objectFit: "cover",
//           }}
//         />
//       </div>
//     </div>
//   );
// }

function Newsletter() {
  return (
    <div
      id="newsletter-section"
      style={{
        width: "100%",
        aspectRatio: "16 / 5",
        // overflow: "hidden",
      }}
      onClick={() => {
        window.location.href = "/book-club";
      }}
    >
      <img
        loading="lazy"
        src="https://images.assettype.com/newslaundry/2026-06-30/ngfd44vp/newsletter.png"
        alt=""
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}





function ContactUs() {
  return (
    <div
      id="contact-section"
      style={{
        background: "#FFF1E8",
        paddingTop: "clamp(8px, 2vw, 16px)",
        paddingLeft: "clamp(48px, 12vw, 88px)",
      }}
    >
      {/* <SectionTitle title="Contact Us" width="8%" /> */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // gap: "6px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            flex: 1,
            minWidth: "260px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              // gap: "6px",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontFamily: "'Lora', serif",
                fontSize: "3rem",
                fontWeight: "bold",
              }}
            >
              Contact Us
            </div>

            <div
              style={{
                borderColor: "#EC2227",
                borderStyle: "solid",
                borderWidth: "2px",
                width: "24%",
                // marginBottom: "1rem",
              }}
            />
          </div>
          {/* <a
            href="tel:+919999999999"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
            }}
          >
            <FaPhoneAlt />
            <span>+91 99999 99999</span>
          </a> */}

          <a
            href="mailto:bookclub@newslaundry.com"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaEnvelope />
            <span>bookclub@newslaundry.com</span>
          </a>

          <a
            href="https://www.instagram.com/newslaundry/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaInstagram />
            <span>https://www.instagram.com/newslaundry</span>
          </a>

          <a
            href="https://x.com/newslaundry"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textDecoration: "none",
              color: "#111827",
              fontWeight: "bold",
            }}
          >
            <FaXTwitter />
            <span>https://x.com/newslaundry</span>
          </a>
        </div>

        <div
          style={{
            flex: 1,
            minWidth: "280px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            loading="lazy"
            src="https://images.assettype.com/newslaundry/2026-05-28/z6r6226b/contact.png"
            alt=""
            style={{
              width: "100%",
              maxWidth: "300px",
              borderRadius: "20px",
              objectFit: "contain",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export function BookClubWebPage() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          aspectRatio: "16 / 9",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src="https://images.assettype.com/newslaundry/2026-06-05/bychsezc/Hero.png"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />

        <button
          onClick={() => scrollToSection("contact-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            top: "clamp(28px,6vw,50px)",
            right: "clamp(40px,8vw,64px)",
            fontFamily: "'Source Sans 3', sans-serif",
          }}
        >
          Contact Us
        </button>

        <button
          onClick={() => scrollToSection("newsletter-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            bottom: "clamp(28px,6vw,50px)",
            left: "clamp(40px,8vw,64px)",
            fontFamily: "'Source Sans 3', sans-serif",
          }}
        >
          Join our Newsletter
        </button>

        <button
          onClick={() => scrollToSection("current-book-section")}
          style={{
            ...buttonStyle,
            position: "absolute",
            bottom: "clamp(28px,6vw,50px)",
            right: "clamp(40px,8vw,64px)",
            fontFamily: "'Source Sans 3', sans-serif",
          }}
        >
          Explore Our Current Book
        </button>
      </div>

      <div
        style={{
          width: "100%",
          aspectRatio: "16 / 6.5",
          overflow: "hidden",
        }}
      >
        <img
          src="https://images.assettype.com/newslaundry/2026-06-05/efnl7bna/About-Us-.png"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>
      <HouseBlocks />
      <div
        id="current-book-section"
        style={{
          width: "100%",
          aspectRatio: "16 / 6",
          overflow: "hidden",
        }}
        onClick={() => {
          window.location.href = "/book-club";
        }}
      >
        <img
          src="https://images.assettype.com/newslaundry/2026-06-19/tux9ylza/book-of-the-month-.png"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      <UpcomingBookBlocks />
      <AuthorEventBlocks />
      {/* <LottieBlock /> */}
      <Newsletter />
      <ContactUs />
    </div>
  );
}
